import { MessageType, MessageLogType } from '../types/render-types';
import { DateTime } from 'luxon';


class Message {
    type: MessageType;
    options: object;
    timestamp: DateTime;

    constructor(type: MessageType, options: object) {
        this.type = type;
        this.options = options;
        this.timestamp = DateTime.local();
    }

    static fromJSON(obj: MessageLogType) {
        let m = new Message(obj.type, obj.options || {} as any);
        m.timestamp = DateTime.fromISO(obj.timestamp);
        return m;
    }

    toJSON(): MessageLogType {
        return {
            type: this.type,
            options: this.options,
            timestamp: this.timestamp.toISO()
        }
    }
}


export {
    Message,
}
